const commonHeaders = {
    'Content-Type': 'application/json;charset=UTF-8',
};

const taasHeaders = {
    'Content-Type': 'application/vnd.com.toyota-europe.taas+json;level=2',
};

const fileHeaders = {
    'Content-Type': 'multipart/form-data',
};

export const getHeaders = () => Object.assign({}, commonHeaders);
export const getTaasHeaders = () => Object.assign({}, taasHeaders);
export const getFileHeaders = () => Object.assign({}, fileHeaders);
